import React, { useState, useEffect } from 'react';
import Field from '../../Field/Field';
import SpaceInvader from '../../SVG/SpaceInvader'
import CTAButton from '../../CTAButton/CTAButton';
import SweetAlert from 'react-bootstrap-sweetalert';
import { checkMarketPlace } from '../../../Utility/HelperFunctions';
import "./EnterLevelModal.scss";
import { MAIN_CONFIG } from '../../../../config/main';


export default ({
  title,
  applicationData,
  handleClose = () => { },
  handleSubmit = () => { },
  alertShow = () => { },
  setUpdateAlert = () => { },
  setLoading = () => { },
  redirectURL=checkMarketPlace()
}) => {

  const [state, setState] = useState({
    renewalAttempt: 0,
    renewal_code: '',
    renewalError: '',
    renewalAlert: ''
  });

  const hideRenewalAlert = () => {
    setUpdateAlert(false)
  }
  const onClose = () => {
    hideRenewalAlert()
    setLoading(true)
    window.location.href = redirectURL
    }

  const onPopupClose = ()=>{
    hideRenewalAlert()
      setLoading(true)
      window.location.href = redirectURL
  }
  const handleStaticRenewalSubmission = (e) => {
    e.preventDefault()
    const totalAttempts = applicationData.no_of_max_retry_attempts__c || 3
    const { renewalAttempt, renewal_code } = state;

    if (applicationData.entry_level_check_value__c === renewal_code) {
      localStorage.setItem('isRenewed', true)
      const getAlert = () => (
        <SweetAlert
          show={true}
          // success
          title="Success!"
          onConfirm={() => hideRenewalAlert()}
          confirmBtnText="Close"
          custom
          confirmBtnCssClass="cta-button CTAWhite tertiary"
          // type={error ? 'error' : 'success'}
          // title={error ? 'Error!' : 'Success!'}
          // onConfirm={() => this.hideAlert()}
          confirmBtnBsStyle="primary"
          customClass="user-confirmation-alert"
          id="copied-clipboard"
          openAnim="false"
          customIcon={MAIN_CONFIG.STATIC_IMAGE_URL.Success_Icon}

        >
          {applicationData.success_message__c || 'Renewal done successfully.'}
        </SweetAlert>
      );

      alertShow(getAlert(), 'entryLevel')
    } else if ((renewalAttempt + 1) > (totalAttempts - 1)) {
      const getAlert = () => (
        <SweetAlert
          show={true}
          error
          title="error!"
          onConfirm={() => onPopupClose()}
          confirmBtnText="Close"
          confirmBtnBsStyle="danger"
        >
          {applicationData.failure_message__c ? applicationData.failure_message__c : "You have completed all attempts, Please go to dashboard and try later."}          </SweetAlert>
      );
      alertShow(getAlert(), 'entryLevel')
    }
    const attempts = parseInt(renewalAttempt) + 1
    const errorMsg = `Unfortunately, this code is incorrect, please try again. You have only ${totalAttempts - attempts} attempts left.`
    setState(prevState => ({
      ...prevState,
      renewalAttempt: attempts,
      renewalError: errorMsg
    }))
  }
  const handleChange = (name, value) => {
    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  return (
    <div id='task-modal-content'>
      <div className="task-head_container entry-level-head-container">
        <div className="HDesktopGreen event-head entry-level-check-desc CTAGreen">{title}</div>
        <a className="event-head cancel-icon H6DesktopGrey" onClick={onClose}>X</a>
      </div>

      <div className="user-task-add__form">
        <form onSubmit={(e) => handleStaticRenewalSubmission(e)}>

          <div className="application-section__question" >
            <label className="application-section__label">
              {/* {title} */}
            </label>
            <Field
              id={'question_id'}
              className="application-section__textarea"

              errorMsg={state.renewalError}
              placeholder='Please answer.'
              type={'text'}
              value={state.renewal_code}
              required={true}
              handleChange={(value) => handleChange('renewal_code', value)}
            />
          </div>

          <div className="applicant-task__submit">
            <CTAButton id='task-page__cta__cancel' type='inverse'  outline onClick={onClose} buttonType="button">
              Cancel
            </CTAButton>

            <CTAButton id='task-page__cta' type='tertiary'>
              Submit
            </CTAButton>
          </div>

        </form>
      </div>
    </div>
  )
}